import { render, staticRenderFns } from "./NewEntryTableSelectorMenu.vue?vue&type=template&id=3dd4d3c9"
import script from "./NewEntryTableSelectorMenu.vue?vue&type=script&lang=js"
export * from "./NewEntryTableSelectorMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports